import axios from "axios";

const state = {
	users: {
		index: null
	}
};

const getters = {
	users: state => {
		return state.users.index;
	},
};

const mutations = {
	setUsersIndex(state, payload) {
		state.users.index = payload;
	},
	clearUsersIndex(state) {
		state.users.index = null;
	},
}

const actions = {
	/* eslint-disable */
	async searchUser( {state}, params = null ) {
		let res = {};
		await axios.get('users/company', {
			params: params
		})
		.then(response => {
			res = {
				success: true,
				data: response.data.data,
				error: null
			}
		})
		.catch(error => {
			console.log("ERROR", error.response)
			res = {
				success: false,
				data: null,
				error: error
			}
		});
		return res;
	},
	/* eslint-enable */
	async getUsersIndex({commit}, params = null) {
		await axios
			.get('users/company', {
				params: params
			})
			.then(response => {
				console.log(response)
				commit('setUsersIndex', response.data.data)
			})
			.catch(e => {
				console.log("GET USER INDEX ERROR", e)
			});
	},
	clearUsersIndex({ commit }) {
		commit('clearUsersIndex')
	}
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
